import { Box, IconButton } from '@mui/material'
import { AgentReplyLeadIcon } from './AgentReplyLeadIcon.jsx'
import { LEAD_ICON_SIZE } from './agentReplyPreambleTokens.js'

export function buildAgentReplyPreambleLead({
  showLeadIcon,
  interactive,
  expanded,
  tracePanelId,
  onToggleExpand,
}) {
  if (!showLeadIcon) {
    return <Box sx={{ width: LEAD_ICON_SIZE, flexShrink: 0 }} aria-hidden />
  }
  if (!interactive) return null

  return (
    <IconButton
      type="button"
      size="small"
      onClick={onToggleExpand}
      aria-expanded={expanded}
      aria-controls={tracePanelId}
      aria-label={expanded ? 'Hide reasoning details' : 'Show reasoning details'}
      sx={{
        p: 0,
        width: 20,
        height: 20,
        minWidth: 20,
        flexShrink: 0,
        borderRadius: 1,
        color: 'text.primary',
        alignSelf: expanded ? 'flex-start' : 'center',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <AgentReplyLeadIcon expanded={expanded} interactive />
    </IconButton>
  )
}
